module.exports = __webpack_public_path__ + "img/manage09.dbd0c159.png";